module.exports = __webpack_public_path__ + "images/99cd5ee91fb41eacd90495c874f9f8dd2.svg";